import validator from 'validator';
import { LoginPageContent } from '../utils/pageContent';

function loginValidation(data) {
  const errors = {};

  if (validator.isEmpty(data.email.trim()))
    errors.email = LoginPageContent.inputFieldLabel.emailErrorMessage.message2;
  else if (!validator.isEmail(data.email)) errors.email = LoginPageContent.inputFieldLabel.emailErrorMessage.message1;

  if (validator.isEmpty(data.password.trim())) errors.password = LoginPageContent.inputFieldLabel.passwordErrorMessage.message1;
  else if (data.password.length < 6) errors.password = LoginPageContent.inputFieldLabel.passwordErrorMessage.message2;

  return { errors, isValid: Object.keys(errors).length <= 0 };
}

export default loginValidation;
